// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section_Section__1v4zT","Header":"Section_Header__2lcn0"};